import { useState, useEffect } from "react";
import {
  GetClientSelectedData,
  GetFilterJobByJobId,
  GetReportsJobTypes,
  GetFilterJobDetails,
  GetReportsLol,
  GetClientResults,
  GetMonthlyMailVolume,
  GetCostReport,
  GetReportsListAnalysisHeadersGrid,
  GetReportListAnalysisDetailData,
  GetFilterJobDaily,
} from "../../../services/accountService";
import { AisScreenLoader } from "../../../utils/AisScreenLoader";
import { useLocation } from "react-router-dom";
// ✅ RBAC
import { canViewFieldOnScreen, hasPermission, getUserTypeID, isListAgent } from '../../../utils/PermissionUtils';

import JobReportsTab from "./tabs/JobReportsTab";
import ListAnalysisTab from "./tabs/ListAnalysisTab";
import VolumeTrackingTab from "./tabs/VolumeTrackingTab";
import FinancialReportTab from "./tabs/FinancialReportTab";

const TABS = ["Job Reports", "List Analysis", "Volume Tracking", "Financial Report"];

const Reports = () => {
 
  const [activeTab, setActiveTab] = useState(() =>
    isListAgent() ? "List Analysis" : "Job Reports"
  );
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingJobTypes, setLoadingJobTypes] = useState(false);
  const [loadingLol, setLoadingLol] = useState(false);

  const [clients, setClients] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);

 
  const [selectedClientId, setSelectedClientId] = useState([]);
  const [jobDetailsJobId, setJobDetailsJobId] = useState([]);

  const location = useLocation();

 
  
  const canViewJobDetail = canViewFieldOnScreen('Reports', 'ReportsList', 'job-detail');
  const canViewJobDaily = canViewFieldOnScreen('Reports', 'ReportsList', 'job-daily');
  const canViewClientResults = canViewFieldOnScreen('Reports', 'ReportsList', 'client-results');
  const canViewMonthlyMailVolume = canViewFieldOnScreen('Reports', 'ReportsList', 'monthly-mail-volume');
 
  const canViewCostReport = isListAgent()
    ? true
    : canViewFieldOnScreen('Reports', 'ReportsList', 'cost-report');
 
  const userTypeID = getUserTypeID();
  const isClientOrConsultant = userTypeID === 2 || userTypeID === 3;

 
  const canViewLol = isListAgent()
    ? true
    : canViewFieldOnScreen('Reports', 'ReportsList', 'lol');
  const canViewHeader = isListAgent()
    ? true
    : canViewFieldOnScreen('Reports', 'ReportsList', 'list-analysis-header');
  const canViewDetail = isListAgent()
    ? true
    : canViewFieldOnScreen('Reports', 'ReportsList', 'list-analysis-detail');
  const canViewTrend = (isClientOrConsultant || isListAgent())
    ? false
    : canViewFieldOnScreen('Reports', 'ReportsList', 'trend-analysis');

  const canViewListAnalysisTab = canViewLol || canViewHeader || canViewDetail || canViewTrend;

  const canExportReports = hasPermission('Reports.Export');

  const visibleTabs = TABS.filter((tab) => {
   
    if (isListAgent()) return tab === "List Analysis";

    if (tab === "Financial Report") return canViewCostReport;
    if (tab === "List Analysis") return canViewListAnalysisTab;
    return true;
  });

  const reportsPermissions = {
   
    canViewJobDetail,
    canViewJobDaily,
   
    canViewLol,
    canViewHeader,
    canViewDetail,
    canViewTrend,
    
    canViewClientResults,
    canViewMonthlyMailVolume,
    
    canViewCostReport,
   
    canExportReports,
  };

 
  const [reportType, setReportType] = useState("Job Detail");
  const [isClientDropdownOpen, setIsClientDropdownOpen] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [jobReportFilters, setJobReportFilters] = useState({
    mailStartDate: "",
    mailEndDate: "",
    jobIDs: "",
    jobTypeIDs: "",
    mailDetailIDs: "",
    listMasterIDs: "",
    talliesStartDate: "",
    talliesEndDate: ""
  });
  
  const [listAnalysisType, setListAnalysisType] = useState("List of Lists");
  const [listOfListsData, setListOfListsData] = useState([]);
  const [listAnalysisHeaderData, setListAnalysisHeaderData] = useState([]);
  const [listAnalysisDetailData, setListAnalysisDetailData] = useState([]);

 
  const [lolFilters, setLolFilters] = useState({
    listName: "",
    fromDate: "",
    toDate: "",
    listId: "",
    jobId: "",
    mailCode: "",
    package: "",
  });

 
  const [headerFilters, setHeaderFilters] = useState({
    listName: "",
    jobId: [],
    manager: "",
    fromDate: "",
    toDate: "",
    jobType: "",
    search: "",
  });

  
  const [detailFilters, setDetailFilters] = useState({
    clientId: "",
    jobId: "",
    fromDate: "",
    toDate: "",
    reh: "",
    jobType: "",
    mailCode: "",
    listName: "",
  });

  
  const [volumeTrackingType, setVolumeTrackingType] = useState("Client Results");
  const [clientResultsData, setClientResultsData] = useState([]);
  const [monthlyMailVolumeDataState, setMonthlyMailVolumeDataState] = useState([]);
  const [clientResultFilters, setClientResultFilters] = useState({
    clientId: [],
    fromDate: "",
    toDate: "",
    jobId: "",
  });
  const [monthlyMailVolumeFilters, setMonthlyMailVolumeFilters] = useState({
    clientId: [],
    fromDate: "",
    toDate: "",
    period: "Monthly",
    jobId: [],
  });




 

  const [financialReportType, setFinancialReportType] = useState("Cost Report");
  const [costReportDataState, setCostReportDataState] = useState([]);
  const [costReportFilters, setCostReportFilters] = useState({
    clientIds: [],
    jobIds: [],
    mailStartDate: "",
    mailEndDate: "",
    estVsActual: "",
    vendor: "",
    costTypeIds: "",
  });

  const extractRows = (response) => {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    if (Array.isArray(response?.data?.data)) return response.data.data;
    if (Array.isArray(response?.result)) return response.result;
    if (Array.isArray(response?.items)) return response.items;
    if (Array.isArray(response?.records)) return response.records;
    return [];
  };

  
  const formatDate = (d) => {
    if (!d) return "";
    const [y, m, day] = d.split("-");
    return `${m}/${day}/${y}`;
  };

  useEffect(() => {
    if (!location.state?.restoreReports) return;

    const type = location.state?.reportType;

    if (type === "Monthly Mail Volume") {

      setActiveTab("Volume Tracking");

      setVolumeTrackingType("Monthly Mail Volume");

      setMonthlyMailVolumeFilters(location.state.reportFilters || {});

      setMonthlyMailVolumeDataState(location.state.rowData || []);

      fetchJobsByClient(location.state.selectedClientIds || []);
      return;
    }

    
    if (type === "Client Results") {

      setActiveTab("Volume Tracking");

      setVolumeTrackingType("Client Results");

      setClientResultFilters(location.state.reportFilters || {});

      setClientResultsData(location.state.rowData || []);

      return;
    }


    
    if (type === "Cost Report") {
      if (!canViewCostReport) return;

      setActiveTab("Financial Report");

      setFinancialReportType(type);

      setCostReportFilters(location.state.reportFilters || {});

      setCostReportDataState(location.state.rowData || []);

      return;
    }

    
    if (type === "List of Lists") {
      if (!canViewListAnalysisTab || !canViewLol) return;

      setActiveTab("List Analysis");

      setListAnalysisType("List of Lists");

      setLolFilters(location.state.reportFilters?.lolFilters || {});

      setSelectedClientId(location.state.selectedClientId || []);

      setListOfListsData(location.state.rowData || []);

      fetchJobsByClient(location.state.selectedClientId || []);

      return;
    }

  
    if (isListAgent()) return;

  
    setActiveTab("Job Reports");

    setJobReportFilters(location.state.reportFilters || {});

    setSelectedClientId(location.state.selectedClientId || []);

    setReportType(type || "Job Detail");

    setRowData(location.state.rowData || []);

  }, [location.state]);


 
  const fetchJobsByClient = async (clientIDs) => {
    if (!clientIDs || clientIDs.length === 0) {
      setJobDetailsJobId([]);
      return;
    }
    setLoading(true);
    try {
      const response = await GetFilterJobByJobId(clientIDs);
      setJobDetailsJobId(Array.isArray(response) ? response : []);
    } catch {
      setJobDetailsJobId([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClientChange = (e) => {
    const id = e.target.value;
    setSelectedClientId(id);
    fetchJobsByClient(id);
  };


  const handleRunReport = async () => {
   
    if (reportType === 'Job Daily' && !canViewJobDaily) return;
    if (reportType === 'Job Detail' && !canViewJobDetail) return;

    setLoading(true);
    try {
      const filters = {
        clientIDs: selectedClientId,
        mailStartDate: formatDate(jobReportFilters.mailStartDate),
        mailEndDate: formatDate(jobReportFilters.mailEndDate),
        jobIDs: jobReportFilters.jobIDs,
        jobTypeIDs: jobReportFilters.jobTypeIDs,
        mailDetailIDs: jobReportFilters.mailDetailIDs,
        listMasterIDs: jobReportFilters.listMasterIDs,
        talliesStartDate: jobReportFilters.talliesStartDate,
        talliesEndDate: jobReportFilters.talliesEndDate
      };
      const response =
        reportType === "Job Daily"
          ? await GetFilterJobDaily(filters)
          : await GetFilterJobDetails(filters);
      setRowData(extractRows(response));
    } catch (error) {
      console.error("Error running job report:", error);
      setRowData([]);
    } finally {
      setLoading(false);
    }
  };

  const resetJobReportFilters = () =>
    setJobReportFilters({
      mailStartDate: "",
      mailEndDate: "",
      jobIDs: "",
      jobTypeIDs: "",
      mailDetailIDs: "",
      listMasterIDs: "",
      talliesStartDate: "",
      talliesEndDate: ""
    });

  const handleClearReport = () => {
    setSelectedClientId("");
    setJobDetailsJobId([]);
    setRowData([]);
    resetJobReportFilters();
  };

  const handleReportTypeChange = (e) => {
    setReportType(e.target.value);
    setSelectedClientId("");
    setJobDetailsJobId([]);
    setRowData([]);
    resetJobReportFilters();
  };

 
  const fetchListOfLists = async (selectedClientIds) => {
    setLoadingLol(true);
    try {
     
      const filters = {};

      
      if (selectedClientIds?.length) {
        filters.ClientIDs = selectedClientIds.join(",");
      }

     
      if (lolFilters.jobIds?.length) {
        filters.JobIDs = lolFilters.jobIds.join(",");
      }

     
      if (lolFilters.listName) {
        filters.ListName = lolFilters.listName;
      }

     
      if (lolFilters.listId) {
        filters.ListID = lolFilters.listId;
      }

     
      if (lolFilters.fromDate) {
        filters.MailStartDate = formatDate(lolFilters.fromDate);
      }
      if (lolFilters.toDate) {
        filters.MailEndDate = formatDate(lolFilters.toDate);
      }

      
      if (lolFilters.mailCode) {
        filters.MailCode = lolFilters.mailCode;
      }

     
      if (lolFilters.postageIds?.length) {
        filters.PostageIDs = lolFilters.postageIds.join(",");
      }

    
      filters.PageNumber = 1;
      filters.PageSize = 100;

      const response = await GetReportsLol(filters);
      const data = extractRows(response);

      const mappedData = data.map((item) => ({
        client: item.client,
        clientId: item.clientID,
        jobId: item.jobID,
        jobName: item.jobName,
        issue: item.issue,
        technique: item.technique,
        mailCode: item.mailCode,
        test: item.test,
        postage: item.postage,
        mailDate: item.mailDate,
        qtyMailed: item.quantityMailed,
        qtyOrdered: item.orderQuantity,
        orderNumber: item.orderNumber,
        listName: item.listName,
        listSelect: item.listSelect,
        listId: item.listID,
        postageIn: item.postageIn,
        postageOut: item.postageOut,
        additionalTitle: "",
      }));

      setListOfListsData(mappedData);
    } catch (error) {
      console.error("Error fetching List of Lists:", error);
      setListOfListsData([]);
    } finally {
      setLoadingLol(false);
    }
  };

  const fetchListAnalysisHeader = async (args = {}) => {
    const { clientIds = [], jobTypeId, ...rest } = args;
    setLoading(true);
    try {
      const filters = {};

      if (clientIds.length) filters.ClientIDs = clientIds.join(",");   // ✅ from child
      if (headerFilters.jobIds?.length) filters.JobIDs = headerFilters.jobIds.join(",");  // ✅ ADD THIS
      if (headerFilters.listName) filters.ListName = headerFilters.listName;
      if (jobTypeId) filters.JobTypeID = jobTypeId;                    // ✅ ID, not name
      if (headerFilters.fromDate) filters.StartDate = formatDate(headerFilters.fromDate);
      if (headerFilters.toDate) filters.EndDate = formatDate(headerFilters.toDate);
      if (headerFilters.manager) filters.ListManagerIDs = headerFilters.manager;
      if (headerFilters.search) filters.Search = headerFilters.search;

      const response = await GetReportsListAnalysisHeadersGrid(filters);
      const data = extractRows(response);
      const mappedData = data.map((item) => ({
        listId: item.listID,
        listName: item.listName,
        listSelect: item.listSelect,
        timesUsed: item.timesUsed,
        lastUsed: item.lastUsed,
        orderQty: item.orderQuantity,
        qtyMailed: item.quantityMailed,
        totalDonors: item.totalDonors,
        totalIncome: item.totalIncome,
        totalListCost: item.totalListCost,
        totalCost: item.totalCost,
        avgOrderQty: item.avgOrderQuantity,
        avgMailedQty: item.avgMailedQuantity,
        keptRate: item.keptRate,
        responseRate: item.responseRate,
        avgGift: item.averageGift,
        incomePerPiece: item.incomePerPiece,
        listCostPerM: item.listCostPerM,
        productionCostPerPiece: item.productionCostPerPiece,
        netPerPiece: item.netPerPiece,
        roi: item.roi,
        returnsThrough: item.returnsThrough,
        jobType: item.jobType,
        reh: item.reh,
      }));
      setListAnalysisHeaderData(mappedData);
    } catch (error) {
      console.error("Error fetching list analysis header:", error);
      setListAnalysisHeaderData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchListAnalysisDetail = async (args = {}) => {
    const {
      clientIds = [],
      jobIds = [],
      jobType,
      reh,
      mailCode,
      listName,
      startDate,
      endDate,
    } = args;

    const filters = {};

    if (clientIds.length) filters.ClientIDs = clientIds.join(",");  
    if (jobIds.length) filters.JobIDs = jobIds.join(",");           
    if (jobType) filters.JobTypeID = jobType;                        
    if (reh) filters.REH = reh;
    if (mailCode) filters.MailCode = mailCode;
    if (listName) filters.ListName = listName;
    if (startDate) filters.StartDate = formatDate(startDate);       
    if (endDate) filters.EndDate = formatDate(endDate);

    setLoading(true);
    try {
      const response = await GetReportListAnalysisDetailData(filters);
      const data = extractRows(response);   
      const mappedData = data.map((item) => ({
        clientId: item.clientID,
        clientName: item.clientName,
        jobId: item.jobID,
        jobName: item.jobName,
        jobType: item.jobType,
        technique: item.technique,
        mailDate: item.mailDate,
        mailCode: item.mailCode,
        listName: item.listName,
        listSelect: item.listSelect,
        qtyMailed: item.quantityMailed,
        orderQty: item.orderQuantity,
        donors: item.donors,
        nonDonors: item.nonDonors,
        responseRate: item.responseRate,
        avgGift: item.averageGift,
        income: item.income,
        cost: item.cost,
        netIncome: item.netIncome,
        incomePerPiece: item.incomePerPiece,
        costPerPiece: item.costPerPiece,
        netPerPiece: item.netPerPiece,
        returnsThrough: item.returnsThrough,
        lastUpdate: item.lastUpdate,
        lastUpdatedBy: item.lastUpdatedBy,
        totalListCost: item.totalListCost,
        orderType: item.orderType,
        reh: item.reh,
      }));
      setListAnalysisDetailData(mappedData);
    } catch (err) {
      console.error("Failed to fetch list analysis detail", err);
      setListAnalysisDetailData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchClientResults = async () => {
    setLoading(true);
    try {
      const activeFilters = {};

      if (clientResultFilters.clientIds?.length > 0) {
        activeFilters.ClientIDs = clientResultFilters.clientIds.join(",");  // ✅ FIX
      } else if (clients?.length > 0) {
        const allClientIds = clients.map(c => c.clientID).join(",");
        activeFilters.ClientIDs = allClientIds;
      }

      if (clientResultFilters.fromDate)
        activeFilters.StartDate = clientResultFilters.fromDate;

      if (clientResultFilters.toDate)
        activeFilters.EndDate = clientResultFilters.toDate;

      const response = await GetClientResults(activeFilters);
      const data = extractRows(response);

      const mappedData = data.map((item) => ({
        clientId: item.clientID,
        clientName: item.clientName,
        mailCode: item.mailCode,
        date: item.date,
        dayOfWeek: item.dayOfWeek,
        nonDonors: item.nonDonors,
        donors: item.donors,
        pieces: item.pieces,
        amount: item.amount,
        periodStart: item.periodStart,
        periodEnd: item.periodEnd,
        batchNumber: item.batchNumber,
      }));

      setClientResultsData(mappedData);
    } catch (error) {
      console.error(error);
      setClientResultsData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClearClientResults = () => {
    setClientResultFilters({ clientId: "", fromDate: "", toDate: "", jobId: "" });
    setClientResultsData([]);
    setSearchText("");
  };

  const fetchMonthlyMailVolume = async () => {
    setLoading(true);
    try {
      const activeFilters = {};

      // Client IDs
      if (monthlyMailVolumeFilters.clientIds?.length > 0) {
        activeFilters.ClientIds = monthlyMailVolumeFilters.clientIds.join(",");


      } else if (clients?.length > 0) {
        const allClientIds = clients.map(c => c.clientID).join(",");
        activeFilters.ClientIds = allClientIds;
      }

      // ✅ FIX: Handle jobIDs array (not jobId)
      if (monthlyMailVolumeFilters.jobIDs?.length > 0) {
        activeFilters.JobIDs = monthlyMailVolumeFilters.jobIDs.join(",");
      }

      // Date Range
      if (monthlyMailVolumeFilters.fromDate)
        activeFilters.MailStartDate = monthlyMailVolumeFilters.fromDate;

      if (monthlyMailVolumeFilters.toDate)
        activeFilters.MailEndDate = monthlyMailVolumeFilters.toDate;

      if (monthlyMailVolumeFilters.period)
        activeFilters.Period = monthlyMailVolumeFilters.period;

      const response = await GetMonthlyMailVolume(activeFilters);
      const data = extractRows(response);

      const mappedData = data.map((item) => ({
        clientID: item.clientID,
        clientName: item.clientName,
        dropDate: item.dropDate,
        jobID: item.jobID,
        jobName: item.jobName,
        jobType: item.jobType,
        month: item.month,
        periodLabel: item.periodLabel,
        quantityMailed: item.quantityMailed,
        totalIncome: item.totalIncome,
        totalMailings: item.totalMailings,
      }));

      setMonthlyMailVolumeDataState(mappedData);
    } catch (error) {
      console.error(error);
      setMonthlyMailVolumeDataState([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tab) => {
   
    if (!visibleTabs.includes(tab)) return;

    
    setLoading(true);

    
    setActiveTab(tab);

    
    setRowData([]);
    setClientResultsData([]);
    setMonthlyMailVolumeDataState([]);
    setCostReportDataState([]);

   
    setTimeout(() => {
      setLoading(false);
    }, 300);
  };


  const handleClearMonthlyMailVolume = () => {
    setMonthlyMailVolumeFilters({
      clientId: "",
      fromDate: "",
      toDate: "",
      period: "Monthly",
      jobId: [],
    });
    setMonthlyMailVolumeDataState([]);
  };

  const fetchCostReport = async () => {
    setLoading(true);
    try {
      const filters = {};
      if (costReportFilters.clientIds?.length)
        filters.ClientIDs = costReportFilters.clientIds.join(",");
     
      if (costReportFilters.jobIds?.length)
        filters.JobIDs = costReportFilters.jobIds.join(",");
      if (costReportFilters.mailStartDate) filters.MailStartDate = formatDate(costReportFilters.mailStartDate);
      if (costReportFilters.mailEndDate) filters.MailEndDate = formatDate(costReportFilters.mailEndDate);
      if (costReportFilters.estVsActual) filters.EstVsActual = costReportFilters.estVsActual;
      if (costReportFilters.vendor) filters.Vendor = costReportFilters.vendor;
      if (costReportFilters.costTypeIds) filters.CostTypeIDs = costReportFilters.costTypeIds;
      filters.PageNumber = 1;
      filters.PageSize = 100;

      const response = await GetCostReport(filters);
      const data = extractRows(response);
      const mappedData = data.map((item) => ({
        clientId: item.clientID,
        clientName: item.clientName,
        jobId: item.jobID,
        jobName: item.jobName,
        mailDate: item.mailDate,
        lastDropDate: item.lastDropDate,
        accountingStatus: item.accountingStatus,
        costStatus: item.costStatus,
        costCategory: item.costCategory,
        costType: item.costType,
        mailCode: item.mailCode,
        qtyMailed: item.quantityMailed,
        clntEstCost: item.clientEstimatedCost,
        estCost: item.estimatedCost,
        actCost: item.actualCost,
        variance: item.variance,
        variancePct: item.variancePct,
        totalCost: item.totalCost,
        costPerPiece: item.costPerPiece,
        costPerThousand: item.costPerThousand,
        vendor: item.vendor,
        poNumber: item.poNumber,
        invoiceNumber: item.invoiceNumber,
        invoiceDate: item.invoiceDate,
      }));
      setCostReportDataState(mappedData);
    } catch (error) {
      console.error("Error fetching cost report:", error);
      setCostReportDataState([]);
    } finally {
      setLoading(false);
    }
  };
  const handleClearCostReport = () => {
    setCostReportFilters({
      clientIds: [],
      jobIds: [],
      mailStartDate: "",
      mailEndDate: "",
      estVsActual: "",
      vendor: "",
      costTypeIds: "",
    });
    setCostReportDataState([]);
  };

 
  useEffect(() => {
    const fetchClients = async () => {
      setLoading(true);
      try {
        const clientData = await GetClientSelectedData();
        setClients(clientData);
      } catch (error) {
        console.error("Error fetching clients:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchClients();
  }, []);

  useEffect(() => {
    const fetchJobTypes = async () => {
      setLoadingJobTypes(true);
      try {
        const response = await GetReportsJobTypes();
        if (response && response.success && Array.isArray(response.data)) {
          setJobTypes(response.data);
        } else {
          setJobTypes([]);
        }
      } catch (error) {
        console.error("Error fetching job types:", error);
        setJobTypes([]);
      } finally {
        setLoadingJobTypes(false);
      }
    };
    fetchJobTypes();
  }, []);


  const onGridReady = (params) => {
   
  };

 
  return (
    <div style={{ padding: "20px" }}>
      {(loading || loadingJobTypes || loadingLol) && <AisScreenLoader />}

      <h3>Reporting Tools</h3>
      <hr />

      {/* Tabs */}
      <div style={styles.tabs}>
        {visibleTabs.map((tab) => (
          <span
            key={tab}
            onClick={() => handleTabChange(tab)}
            style={{
              ...styles.tab,
              borderBottom: activeTab === tab ? "3px solid #0f4c81" : "none",
              color: activeTab === tab ? "#0f4c81" : "#555",
              fontWeight: activeTab === tab ? "600" : "400",
            }}
          >
            {tab}
          </span>
        ))}
      </div>

      {activeTab === "Job Reports" && (
        <JobReportsTab
          styles={styles}
          clients={clients}
          jobTypes={jobTypes}
          reportType={reportType}
          handleReportTypeChange={handleReportTypeChange}
          selectedClientId={selectedClientId}
          setSelectedClientId={setSelectedClientId}
          isClientDropdownOpen={isClientDropdownOpen}
          setIsClientDropdownOpen={setIsClientDropdownOpen}
          fetchJobsByClient={fetchJobsByClient}
          jobDetailsJobId={jobDetailsJobId}
          jobReportFilters={jobReportFilters}
          setJobReportFilters={setJobReportFilters}
          handleRunReport={handleRunReport}
          handleClearReport={handleClearReport}
          rowData={rowData}
          searchText={searchText}
          setSearchText={setSearchText}
          onGridReady={onGridReady}
          permissions={reportsPermissions}
        />
      )}

    
      {activeTab === "List Analysis" && canViewListAnalysisTab && (
        <ListAnalysisTab
          styles={styles}
          setJobTypes={setJobTypes}
          clients={clients}
          jobTypes={jobTypes}
          fetchJobsByClient={fetchJobsByClient}
          listAnalysisType={listAnalysisType}
          setListAnalysisType={setListAnalysisType}
          selectedClientId={selectedClientId}
          handleClientChange={handleClientChange}
          jobDetailsJobId={jobDetailsJobId}
          searchText={searchText}
          setSearchText={setSearchText}
          onGridReady={onGridReady}
         
          listOfListsData={listOfListsData}
          setListOfListsData={setListOfListsData}
          fetchListOfLists={fetchListOfLists}
          lolFilters={lolFilters}
          setLolFilters={setLolFilters}
        
          listAnalysisHeaderData={listAnalysisHeaderData}
          setListAnalysisHeaderData={setListAnalysisHeaderData}
          headerFilters={headerFilters}
          setHeaderFilters={setHeaderFilters}
          fetchListAnalysisHeader={fetchListAnalysisHeader}
         
          listAnalysisDetailData={listAnalysisDetailData}
          setListAnalysisDetailData={setListAnalysisDetailData}
          detailFilters={detailFilters}
          setDetailFilters={setDetailFilters}
          fetchListAnalysisDetail={fetchListAnalysisDetail}
          permissions={reportsPermissions}
        />
      )}

      {activeTab === "Volume Tracking" && (
        <VolumeTrackingTab
          styles={styles}
          clients={clients}
          fetchJobsByClient={fetchJobsByClient}
          volumeTrackingType={volumeTrackingType}
          setVolumeTrackingType={setVolumeTrackingType}
          searchText={searchText}
          setSearchText={setSearchText}
          onGridReady={onGridReady}
          jobDetailsJobId={jobDetailsJobId}
          clientResultsData={clientResultsData}
          clientResultFilters={clientResultFilters}
          setClientResultFilters={setClientResultFilters}
          fetchClientResults={fetchClientResults}
          handleClearClientResults={handleClearClientResults}
          monthlyMailVolumeDataState={monthlyMailVolumeDataState}
          monthlyMailVolumeFilters={monthlyMailVolumeFilters}
          setMonthlyMailVolumeFilters={setMonthlyMailVolumeFilters}
          fetchMonthlyMailVolume={fetchMonthlyMailVolume}
          handleClearMonthlyMailVolume={handleClearMonthlyMailVolume}
          permissions={reportsPermissions}
        />
      )}

    
      {activeTab === "Financial Report" && canViewCostReport && (
        <FinancialReportTab
          styles={styles}
          clients={clients}
          fetchJobsByClient={fetchJobsByClient}
          financialReportType={financialReportType}
          setFinancialReportType={setFinancialReportType}
          searchText={searchText}
          setSearchText={setSearchText}
          onGridReady={onGridReady}
          costReportDataState={costReportDataState}
          costReportFilters={costReportFilters}
          setCostReportFilters={setCostReportFilters}
          fetchCostReport={fetchCostReport}
          handleClearCostReport={handleClearCostReport}
          jobDetailsJobId={jobDetailsJobId}
        />
      )}
    </div>
  );
};

export default Reports;

const styles = {
  tabs: {
    display: "flex",
    gap: "20px",
    marginTop: "10px",
  },
  tab: {
    cursor: "pointer",
    paddingBottom: "6px",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginTop: "5px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  },
};